<app-schedule-tasks-list
  [data]="data"
  [events]="events"
  [eventData]="eventData"
  (OpenModalEvent)="dialogAction($event)"
></app-schedule-tasks-list>
